import * as http from 'utils/http';
import config from 'config';

export async function getManagedBy(journeyId) {
  try {
    const statuses = await http.get(
      `${config.API_URL}api/delfos/proxy/appusage/?journey_id=${journeyId}`
    );
    return statuses[0]?.managed_by;
  } catch (e) {
    console.error(e);
  }
}
